import React from 'react'
import { InputNumber } from 'primereact/inputnumber'
import { SelectButton } from 'primereact/selectbutton'
import {
  getDefaultMeasurementSystem,
  MIN_HEIGHT_CM,
  MAX_HEIGHT_CM,
  toCentimeters,
} from 'util/helpers.converters'
import { FloatLabel } from 'primereact/floatlabel'
import { EditableDropdown } from './EditableDropdown'

type HeightInputProps = {
  value:number | null
  onChange:(_:number | null) => void
  errors?:string
}

const HeightInput: React.FC<HeightInputProps> = (props) => {
  const [stateUnits,setUnits] = React.useState(getDefaultMeasurementSystem(navigator.language))

  const generateFtMeasurements = (minFt: number, maxFt: number) =>
    Array.from({ length: maxFt - minFt + 1 }, (_, i) => i + minFt)
      .flatMap(feet =>
        Array.from({ length: 12 }, (_, inches) => ({
          display: `${feet}' ${inches}"`,
          height: { feet, inches },
          cm: Math.round(toCentimeters(feet,inches))
        }))
      )

  return (
    <div className="w-100">
      <div className="d-flex flex-grow-1 justify-content-between gap-2">
        {stateUnits == 'imperial'
          ?
              <div className="w-50">
                <EditableDropdown
                    id="imperialHeight"
                    name="imperialHeight"
                    label="Measurement"
                    containerClass="w-100"
                    errors={props.errors}
                    options={generateFtMeasurements(4,7)}
                    optionLabel="display"
                    optionValue="cm"
                    value={props.value ?? undefined}
                    onChange={(e) => {
                      props.onChange(e.value ?? null)
                    }}
                  />
              </div>
          :
            <div className="w-100">
              <FloatLabel>
                <InputNumber
                  buttonLayout="horizontal"
                  id="number-input"
                  name="number-input"
                  value={props.value}
                  onValueChange={(e) => props.onChange(e.value === undefined ? null : e.value && Math.round(e.value))}
                  // showButtons
                  placeholder="cm"
                  mode="decimal"
                  min={props.value ? MIN_HEIGHT_CM : undefined}
                  max={MAX_HEIGHT_CM}
                />
                <label htmlFor="number-input">Centimeters</label>
              </FloatLabel>
            </div>
        }
        <div className="text-nowrap">
          <SelectButton
            value={stateUnits}
            onChange={(e) => setUnits(e.value)}
            options={[{ 'value':'metric','label':'cm' },{ 'value':'imperial','label':'ft/in' }]}
          />
        </div>
      </div>
      {!!props.errors && <small id="height-error" className="text-danger">{props.errors}</small>}
    </div>
  )
}

export default HeightInput
